/* Sprachwahl der App — ohne Abhängigkeit von vue-i18n und den Sprachdateien, damit sie ohne Browser
 * testbar ist (src/domain/detectLocale.test.js).
 *
 * Regel (Entscheidung Bastian, 2026-10-06): Die Ausgangssprache der Website ist IMMER Englisch.
 * Deutsch, Französisch und Spanisch sind Zusatz und werden nur über die Sprachauswahl gewählt.
 *   1. was der Nutzer zuletzt gewählt hat (localStorage) — wer schon umgestellt hat, behält seine Sprache
 *   2. sonst Englisch
 * Die Sprache des Browsers wird NICHT ausgewertet — auch nicht für Anmelde- und Anfrageseite.
 */

export const SUPPORTED_LOCALES = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fr', label: 'Français' },
  { code: 'es', label: 'Español' },
];

export const FALLBACK_LOCALE = 'en';
export const LOCALE_STORAGE_KEY = 'grassrunners.locale';

export function isSupported(code) {
  return SUPPORTED_LOCALES.some((l) => l.code === code);
}

/** `storage` ist localStorage (austauschbar für Tests); ohne Zugriff oder mit ungültigem Wert gilt Englisch. */
export function detectLocale(storage = globalThis.localStorage) {
  try {
    const saved = storage.getItem(LOCALE_STORAGE_KEY);
    if (isSupported(saved)) return saved;
  } catch {
    /* privates Fenster oder blockierte Speicherung — weiter mit Englisch */
  }
  return FALLBACK_LOCALE;
}

export function persistLocale(code, storage = globalThis.localStorage) {
  try {
    storage.setItem(LOCALE_STORAGE_KEY, code);
  } catch {
    /* nicht kritisch: die Wahl gilt dann nur für diese Sitzung */
  }
}
